import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  OnChanges, AfterViewChecked
} from '@angular/core';
import { FormBuilder, FormControl, Validators, AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { ExcessProtectService } from '../excess.service';
import { ExcessProtect } from '../../../model/quote/excessprotect/excessprotect.model';
import { QuoteService } from '../../quote.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from '../../../../environments/environment';
import { formatDate } from '@angular/common';
import { ProductBasedConfigurationService } from '../../../product-based-configuration/product-based-configuration.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-excessprotect-proposer-details',
  templateUrl: './excessprotect-proposer-details.component.html',
  styleUrls: ['./excessprotect-proposer-details.component.css', '../../quote.component.css']
})
export class ExcessProtectProposerDetailsComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {

  addresses;
  formFields: any;
  private postcodeLookupSubject = new Subject<string>();
  private postcodeLookupSubscription: Subscription;
  submitted = false;
  isBroker = false;
  brokers: any = [];
  showContactDetails = false;
  UK_HB_INSURANCE_COMPANY_ID = '';
  quote_type: number = this.route.snapshot.params.quote_type ? this.route.snapshot.params.quote_type : 1;
  ratingType: any;

  // Dates
  isEffectiveDatePast = false;
  currDate = new Date();
  minEffectiveDate = new Date();
  minInceptionDate = new Date();
  maxInceptionDate = new Date();
  maxDob: any = new Date();
  excludedPrefixes: string[] = [];

  // Input Decorators
  @Input() staticData;
  @Input() authDetails;
  @Input() apiModelObject;
  @Input() mtaFinancials: any;

  modelObject = new ExcessProtect();

  // Output Decorators
  @Output() modelObjectUpdated = new EventEmitter<ExcessProtect>();
  policyEndDateMax: Date = new Date();
  @Output() isFleetActivated = new EventEmitter<boolean>();
  @Output() mtaFinancialsUpdated = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private excessProtectService: ExcessProtectService,
    private quoteService: QuoteService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private sessionState: LocalStorageService,
    private cdr: ChangeDetectorRef, private router: Router,
    private productBasedConfigurationService: ProductBasedConfigurationService
  ) { }

  ngOnInit(): void {
    this.getBrokers();

    this.formFields = this.formBuilder.group({
      inception_date: ['', Validators.required],
      cover_to: ['', Validators.required],
      company_id: ['', Validators.required],
      effective_date: ['', Validators.required],
      proposer: this.proposerDetails(),
      // rating_type: ['', Validators.required],
      vehicles: this.formBuilder.array([])
    });

    const maxDate = new Date().setDate(new Date().getDate() + 30);
    this.maxInceptionDate = new Date(maxDate);

    const currentDate = new Date();
    currentDate.setFullYear(new Date().getFullYear() - 18);
    this.maxDob = currentDate.toISOString().slice(0, 10);

    if (this.quote_type && this.quote_type != 3) {
      this.formFields.get('effective_date').disable();
    }
    else {
      this.formFields.get('effective_date').enable();
    }
    if (this.quote_type && this.quote_type == 4) {
      this.formFields.get('effective_date').enable();
    }
    if ((this.quote_type) && (this.quote_type == 3 || this.quote_type == 4)) {
      this.formFields.get('effective_date').enable();
      this.formFields.get('inception_date').disable();
      this.formFields.get('cover_to').disable();
    } else {
      this.formFields.get('effective_date').disable();
      this.formFields.get('inception_date').enable();
      this.formFields.get('cover_to').enable();
    }

    if (this.sessionState.retrieve('is_broker')) {
      this.isBroker = true;
      this.formFields.get('company_id').setValue(this.sessionState.retrieve('broker_company_id'));
    }
    this.UK_HB_INSURANCE_COMPANY_ID = environment.UK_HB_INSURANCE_COMPANY_ID;
    this.gePostcodes(this.sessionState.retrieve('broker_company_id'), environment.EXCESS_PROTECT_ID);

    this.postcodeLookupSubscription = this.postcodeLookupSubject.pipe(debounceTime(400)).subscribe((postcode) => {
      this.doPostcodeLookup(postcode);
    });
  }

  ngOnDestroy() {
    if (this.postcodeLookupSubscription) {
      this.postcodeLookupSubscription.unsubscribe();
    }
  }

  initVehicles() {
    return this.formBuilder.group({
      registration_number: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.apiModelObject) {
      this.modelObject = this.mapApiToExcessProtect(this.apiModelObject);
      if (this.apiModelObject.policy_holder.is_micro_enterprise == 1) {
        this.modelObject.proposer.micro_enterprise = true;
      }
      else {
        this.modelObject.proposer.micro_enterprise = false;
      }
      if (this.apiModelObject.policy_holder.proposer_type == 1) {
        this.modelObject.proposer.proposer_type = 'individual';
      }
      else if (this.apiModelObject.policy_holder.proposer_type == 2)
        this.modelObject.proposer.proposer_type = 'joint';
      else {
        this.modelObject.proposer.proposer_type = 'company';
      }
      const inception_date = new Date(this.modelObject.inception_date);
      const effectiveDate = new Date(this.modelObject.effectiveDate);


      const curr_date = new Date();
      // if (this.apiModelObj.type == 1 && inception_date > curr_date) {
      //   this.minInceptionDate = new Date();
      // } else {
      //   this.minInceptionDate = new Date(this.modelObject.inception_date);
      // }
      if (this.apiModelObject.type == 3) {
        //this.quote_type = 3;
        if (effectiveDate < curr_date) {
          this.isEffectiveDatePast = true;
          this.minEffectiveDate = new Date();
        } else {
          this.isEffectiveDatePast = false;
        }
      }
      if (this.quote_type == 3) {
        if (effectiveDate < curr_date) {
          this.isEffectiveDatePast = true;
          this.minEffectiveDate = new Date();
        } else {
          this.isEffectiveDatePast = false;
        }
      }
      if (this.apiModelObject.is_send_email === 1) {
        this.showContactDetails = true;
      }

      this.showContactDetails = true;
      this.patchValues();

      this.disablePropserFields(this.modelObject.proposer.proposer_type);

      this.gePostcodes(this.sessionState.retrieve('broker_company_id'), environment.EXCESS_PROTECT_ID);
    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  get proposerControls() {
    return ((this.formFields.get('proposer') as FormGroup).controls);
  }

  get proposerAddressControls() {
    return ((this.proposerControls.address as FormGroup).controls);
  }

  get f(): { [key: string]: AbstractControl } {
    if (this.formFields) {
      return this.formFields.controls;
    }
  }

  disablePropserFields(proposer_type: string) {
    if (proposer_type == 'individual') {
      this.proposerControls.title.enable();
      this.proposerControls.first_name.enable();
      this.proposerControls.last_name.enable();
      this.proposerControls.dob.enable();
      this.proposerControls.micro_enterprise.disable();
      this.proposerControls.company_name.disable();
      this.proposerControls.year.disable();
    } else {
      this.proposerControls.title.disable();
      this.proposerControls.first_name.disable();
      this.proposerControls.last_name.disable();
      this.proposerControls.dob.disable();

      this.proposerControls.micro_enterprise.enable();
      this.proposerControls.company_name.enable();
      this.proposerControls.year.enable();

      if (proposer_type == 'joint') {
        this.proposerControls.year.disable();
        this.proposerControls.micro_enterprise.disable();
      }
    }
  }

  public getBrokers() {
    this.quoteService.getBrokers(8) // 'product_type' should be 7, but isn't implemented in the back-end API.
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.brokers = response.result;
          }
        },
        (error) => { }
      );
  }

  /**
   * Get broker commission fee and reset form
   * @param event 
   */
  public getBrokerCommission(event) {
    const brokerDetails = this.brokers.filter((x => x.id == event.value));
    if (brokerDetails.length > 0) {
      if (brokerDetails[0].is_send_email == 1) {
        this.proposerControls.email?.clearValidators();
        this.proposerControls.phone?.clearValidators();
        this.proposerControls.email?.setValue('');
        this.proposerControls.phone?.setValue('');
        this.proposerControls.is_phone?.setValue(0);
        this.proposerControls.is_email?.setValue(0);
        this.proposerControls.sms?.setValue(0);
        this.proposerControls.post?.setValue(0);

        this.proposerControls.email?.updateValueAndValidity();

        this.proposerControls.phone?.updateValueAndValidity();
      }

      // set comission fees
      this.modelObject.brokerComission = brokerDetails[0].broker_commission;
      this.modelObject.brokerAdminFee = brokerDetails[0].broker_admin_fee;
    }
    this.showContactDetails = true;
  }

  onPolicyStartDateChange(event) {
    this.setCoverToDate(event.value);
  }

  onProposerChange(event) {
    this.disablePropserFields(event.value);
  }

  /** Called when user selects an address. Supports backend (id + getAddressById) and legacy full object. */
  onSelectAddress(record: any) {
    if (!record) return;
    const currentPostcode = this.proposerAddressControls.postcode.value;
    if (record.id != null && record.id !== '') {
      this.quoteService.getAddressById(record.id).subscribe({
        next: (full: any) => {
          this.applyAddressToForm(full);
          setTimeout(() => {
            if (this.proposerAddressControls.postcode.value !== currentPostcode) {
              this.proposerAddressControls.postcode.setValue(currentPostcode);
            }
          }, 0);
        },
        error: () => {}
      });
      return;
    }
    this.applyAddressToForm(record);
    setTimeout(() => {
      if (this.proposerAddressControls.postcode.value !== currentPostcode) {
        this.proposerAddressControls.postcode.setValue(currentPostcode);
      }
    }, 0);
  }

  private applyAddressToForm(address: any) {
    if (!address || !this.proposerAddressControls) return;
    const a = address;
    const line1 = a.line1 ?? '';
    const line2 = a.line2 ?? '';
    const line3 = a.line3 ?? '';
    const county = a.county ?? '';
    const postcode = a.postcode ?? '';
    this.proposerAddressControls.line1.setValue(line1 || '');
    this.proposerAddressControls.line2.setValue(line2 || '');
    this.proposerAddressControls.line3.setValue(line3 || '');
    this.proposerAddressControls.county.setValue(county || '');
    if (postcode) this.proposerAddressControls.postcode.setValue(postcode);
  }

  onSubmit() {
    this.submitted = true;

    if (this.quote_type != 3 && !this.modelObject.effectiveDate) {
      this.formFields.get('effective_date')!.disable();
    }

    if (this.formFields.invalid) {
      const firstInvalidControl = document.querySelector('.ng-invalid');
      if (firstInvalidControl) {
        (firstInvalidControl as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
        (firstInvalidControl as HTMLElement).focus();
      }
      return false;
    }

    const formData = this.formFields.value;

    // if (this.quote_type == 3) {
    //   this.modelObject.inception_date = this.modelObject.inception_date;
    // }
    // else {
    //   this.modelObject.inception_date = formatDate(formData.inception_date, 'yyyy-MM-dd', 'en-US');
    // }

    this.modelObject.cover_to = formData.cover_to;
    this.modelObject.broker_id = this.sessionState.retrieve('userInfo').id;
    this.modelObject.proposer = formData.proposer;

    if (this.sessionState.retrieve('company_role') == 'Broker') {
      this.modelObject.company_id = this.sessionState.retrieve('broker_company_id');
    } else {
      this.modelObject.company_id = formData.company_id;
    }

    // FIXED: Only clear vehicles for NEW quotes, not for MTA or existing quotes
    if (!this.route.snapshot.params.id && !this.modelObject.id && this.quote_type != 3) {
      this.modelObject.vehicles = null;
      this.modelObject.fleet_experiences = null;
    }

    if (this.quote_type == 3 || this.quote_type == 4) {
      this.modelObject.inception_date = this.modelObject.inception_date;
    }
    else {
      this.modelObject.inception_date = formatDate(formData.inception_date, 'yyyy-MM-dd', 'en-US');
    }

    if (formData.proposer && formData.proposer.dob) {
      if (formData.proposer.dob) {
        this.modelObject.proposer.dob = formatDate(formData.proposer.dob, 'yyyy-MM-dd', 'en-US');
      }
      if (formData.proposer.licence_length) {
        this.modelObject.proposer.licence_length = formatDate(formData.proposer.licence_length, 'yyyy-MM-dd', 'en-US');
      }
    }

    this.modelObject.declaration = true;

    // Store original ID and preserve vehicle data for MTA
    let originalQuoteId = this.modelObject.id;

    if (this.quote_type == 3) {
      if (this.apiModelObject && this.apiModelObject.id) {
        this.modelObject.policyId = this.apiModelObject.id;
        //this.modelObject.effectiveDate = formatDate(formData.effective_date, 'yyyy-MM-dd', 'en-US');
        this.modelObject.oldPolicyId = originalQuoteId;
        this.modelObject.type = 3;

        let effectiveDate: any = null;

        if (formData?.effective_date) {
          effectiveDate = formData.effective_date;
        } else if (this.modelObject?.effectiveDate) {
          effectiveDate = this.modelObject.effectiveDate;
        } else if (this.apiModelObject?.effectiveDate) {
          effectiveDate = this.apiModelObject.effectiveDate;
        }

        if (effectiveDate) {
          this.modelObject.effectiveDate = formatDate(
            new Date(effectiveDate),
            'yyyy-MM-dd',
            'en-US'
          );
        }

        // Keep vehicles from the original policy
        if (!this.modelObject.vehicles || this.modelObject.vehicles.length === 0) {
          this.modelObject.vehicles = this.apiModelObject.vehicles ?? [];
        }
      }
    }

    if (this.modelObject.type == 2) {
      this.modelObject.policyId = null;
      this.modelObject.effectiveDate = null;
    }

    // Ensure vehicles are properly formatted
    if (this.modelObject.vehicles && this.modelObject.vehicles.length > 0) {
      this.modelObject.vehicles.forEach((res, i) => {
        res.registration_number = (res.registration_number) ? res.registration_number : '';
        res.make = (res.make) ? res.make : '';
        res.model = (res.model) ? res.model : '';
      });
    }
    const isNewMTA = this.route.snapshot.params.quote_type == 3 && this.modelObject.id === this.route.snapshot.params.id;
    //const isNewMTA = this.quote_type == 3 && !this.route.snapshot.params.id;
    console.log(this.modelObject.company_id);
    const data = {
      "quote_data": {
        "type": this.quote_type,
        "id": isNewMTA || this.route.snapshot.params.quote_type == 4 ? null : this.modelObject.id,
        "broker_id": this.modelObject.broker_id,
        "company_id": this.modelObject.company_id,
        "sequence_number": this.modelObject.sequenceNumber,
        "policy_start_date": this.modelObject.inception_date,
        "policy_end_date": this.modelObject.cover_to,
        "policy_ref_number": this.modelObject.policyRefNumber,
        "old_policy_id": this.quote_type == 3 ? originalQuoteId : (this.modelObject.oldPolicyId || null),
        "policy_id": this.quote_type == 3 ? this.apiModelObject.id : (this.modelObject.policyId || null),
        "effective_date": this.quote_type == 3 || this.quote_type == 4 ? this.modelObject.effectiveDate : null,

        "quote_meta_id": this.modelObject.quoteMetaId,
        //"excess_protect_cover_id": isNewMTA ? null: this.modelObject.excess_protect_cover_id,
        "excess_protect_cover_id": this.modelObject.excess_protect_cover_id,
        "policy_holder": {
          "title": this.modelObject.proposer.title,
          "first_name": this.modelObject.proposer.first_name,
          "last_name": this.modelObject.proposer.last_name,
          "email": this.modelObject.proposer.email,
          "phone": this.modelObject.proposer.phone,
          "mobile": this.modelObject.proposer.mobile ? this.modelObject.proposer.mobile : '',
          "dob": this.modelObject.proposer.dob,
          "company_name": this.modelObject.proposer.company_name ? this.modelObject.proposer.company_name : '',
          "trading_name": this.modelObject.proposer.trading_name ? this.modelObject.proposer.trading_name : '',
          "proposer_type": this.modelObject.proposer.proposer_type,
          "year": this.modelObject.proposer.year,
          "micro_enterprise": this.modelObject.proposer.micro_enterprise,
        },
        "address": {
          "address1": this.modelObject.proposer.address.line1,
          "address2": this.modelObject.proposer.address.line2,
          "address3": this.modelObject.proposer.address.line3,
          "address4": "",
          "address5": "",
          "city": this.proposerAddressControls.county.value,
          "country": "UK",
          "postcode": this.proposerAddressControls.postcode.value,
        },
        "sms": this.modelObject.proposer.sms,
        "post": this.modelObject.proposer.post,
        "is_phone": this.modelObject.proposer.is_phone,
        "is_email": this.modelObject.proposer.is_email,
        "vehicle_details": this.modelObject.vehicles,
        'send_email': 0
      }
    };

    this.excessProtectService.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            if (res.result.quote_data) {
              const apiObj = res.result.quote_data.quote_versions[0];
              this.modelObject = this.mapApiToExcessProtect(apiObj);

              // For MTA, preserve the original policy reference and vehicles
              if (this.quote_type == 3) {
                this.modelObject.policyId = this.apiModelObject.id;
                this.modelObject.oldPolicyId = originalQuoteId;
                this.modelObject.type = 3;
                // Get raw value from the form control (works even if disabled)
                const effectiveDateValue = this.formFields.get('effective_date')?.value;

                // Only format if we have a valid value
                if (effectiveDateValue) {
                  this.modelObject.effectiveDate = formatDate(effectiveDateValue, 'yyyy-MM-dd', 'en-US');
                } else if (this.modelObject.effectiveDate) {
                  // If no form value, ensure the existing value is properly formatted
                  this.modelObject.effectiveDate = formatDate(
                    new Date(this.modelObject.effectiveDate),
                    'yyyy-MM-dd',
                    'en-US'
                  );
                }

                // Ensure vehicles are preserved
                if (!this.modelObject.vehicles || this.modelObject.vehicles.length === 0) {
                  this.modelObject.vehicles = this.apiModelObject.vehicles ?? [];
                }
              }

              if (this.route.snapshot.params.quote_type != 4) {
                this.modelObjectUpdated.emit(this.modelObject);
              }
              else {
                //this.router.navigateByUrl("/policy-list");
                this.router.navigateByUrl('/excess-protect/policy/' + res.result.quote_data.quote_versions[0].id);
              }
            }
          } else {
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }
        });
  }

  patchValues() {
    // var effective_date = (new Date(this.modelObject.inception_date) < new Date()) ? new Date() : this.modelObject.inception_date;
    let effectiveDate = this.isEffectiveDatePast ? new Date(this.minEffectiveDate) : this.modelObject.inception_date;
    if (this.modelObject.effectiveDate) {
      effectiveDate = new Date(this.modelObject.effectiveDate);
    }
    this.formFields.patchValue({
      inception_date: this.modelObject.inception_date,
      company_id: this.modelObject.company_id,
      proposer: this.modelObject.proposer,
      // rating_type: this.modelObject.ratingType,
      effective_date: effectiveDate,
    });

    if (this.sessionState.retrieve('is_broker')) {
      this.formFields.get('company_id').setValue(this.sessionState.retrieve('broker_company_id'));
    }

    this.setCoverToDate(this.modelObject.inception_date);
    //this.ratingType(this.modelObject.ratingType);

    if (this.apiModelObject.financial_details) {
      this.modelObject.brokerComission = this.apiModelObject.financial_details.broker_commission;
      this.modelObject.brokerAdminFee = this.apiModelObject.financial_details.broker_admin_fee;
    } else {
      const brokerDetails = this.brokers.filter((x => x.id === this.modelObject.company_id));
      if (brokerDetails.length > 0) {
        this.modelObject.brokerComission = brokerDetails[0].broker_commission;
        this.modelObject.brokerAdminFee = brokerDetails[0].broker_admin_fee;
      }
    }
  }

  // postcodeLookup(event) {
  //   const postcode = event.target.value;
  //   this.quoteService.getAddressPostcodeLookup(postcode)
  //     .subscribe(
  //       (response: any) => {
  //         this.addresses = response.addresses;
  //       },
  //       (error) => {
  //         ;
  //       }
  //     );
  // }


  postcodeError: string | null = null;

  postcodeLookup(event: any) {
    const rawPostcode = (event?.target?.value || '').trim();
    if (!rawPostcode) {
      this.addresses = [];
      this.postcodeError = null;
      return;
    }
    if (rawPostcode.length < 4) {
      this.addresses = [];
      return;
    }
    if (this.excludedPrefixes && this.excludedPrefixes.length > 0) {
      const postcode = rawPostcode.toUpperCase().replace(/\s+/g, '');
      const isExcluded = this.excludedPrefixes.some(prefix => postcode.startsWith(prefix));
      if (isExcluded) {
        this.addresses = [];
        this.postcodeError = 'This postcode is not allowed for this product.';
        return;
      }
    }
    this.postcodeError = null;
    this.postcodeLookupSubject.next(rawPostcode);
  }

  private doPostcodeLookup(rawPostcode: string) {
    const trimmed = (rawPostcode || '').trim();
    if (!trimmed || trimmed.length < 4) {
      this.addresses = [];
      return;
    }
    if (this.excludedPrefixes && this.excludedPrefixes.length > 0) {
      const postcode = trimmed.toUpperCase().replace(/\s+/g, '');
      if (this.excludedPrefixes.some(prefix => postcode.startsWith(prefix))) {
        this.addresses = [];
        this.postcodeError = 'This postcode is not allowed for this product.';
        return;
      }
    }
    this.quoteService.getAddress(trimmed).subscribe({
      next: (response: any) => {
        const records = response?.records || response?.addresses || [];
        this.addresses = Array.isArray(records) ? records : [];
      },
      error: () => { this.addresses = []; }
    });
  }

  proposerDetails() {
    return this.formBuilder.group({
      proposer_type: ['', Validators.required],
      micro_enterprise: ['', Validators.required],
      company_name: ['', Validators.required],
      trading_name: [''],
      year: ['', Validators.required],
      address: this.proposerAddress(),

      title: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: [''],
      dob: ['', Validators.required],
      email: ['', Validators.email],
      phone: [''],
      is_email: [0],
      is_phone: [0],
      sms: [0],
      post: [0],
    });

    this.formFields.get('company_id')?.valueChanges.subscribe((company_id) => {
      if (company_id === '2') {
        // Add required validators if company_name is 2
        this.formFields.get('email')?.setValidators([Validators.required, Validators.email]);
        this.formFields.get('phone')?.setValidators([Validators.required]);
      } else {
        // Remove required validators otherwise
        this.formFields.get('email')?.clearValidators();
        this.formFields.get('phone')?.clearValidators();
      }
      // Update validity after adding/removing validators
      this.formFields.get('email')?.updateValueAndValidity();
      this.formFields.get('phone')?.updateValueAndValidity();
    });
  }

  proposerAddress() {
    return this.formBuilder.group({
      line1: ['', Validators.required],
      line2: [''],
      line3: [''],
      county: ['', Validators.required],
      postcode: ['', Validators.required]
    });
  }

  setCoverToDate(value) {
    const maxDate = new Date(value).setFullYear(new Date(value).getFullYear() + 1);
    this.policyEndDateMax = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
    this.formFields.get('cover_to').setValue(this.policyEndDateMax);
  }

  private mapApiToExcessProtect(api: any): ExcessProtect {
    const model = new ExcessProtect();

    model.id = api.id;
    model.type = api.type;
    model.broker_id = api.broker_id;
    model.company_id = api.company_id;
    model.sequenceNumber = api.sequence_number;
    model.policyRefNumber = api.policy_ref_number;
    model.quoteMetaId = api.quote_meta_id;
    model.excess_protect_cover_id = api.excess_protect_cover_id;

    model.inception_date = api.policy_start_date;
    model.cover_to = api.policy_end_date;

    // Add MTA-specific fields
    model.policyId = api.policy_id;
    model.oldPolicyId = api.old_policy_id;
    model.effectiveDate = api.effective_date;

    // proposer
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.first_name = api.policy_holder.first_name;
    model.proposer.last_name = api.policy_holder.last_name;
    model.proposer.title = api.policy_holder.title;
    model.proposer.dob = api.policy_holder.dob;
    model.proposer.email = api.policy_holder.email;
    model.proposer.phone = api.policy_holder.phone;
    model.proposer.is_phone = api.policy_holder.is_phone;
    model.proposer.sms = api.policy_holder.sms;
    model.proposer.post = api.policy_holder.post;
    model.proposer.is_email = api.policy_holder.is_email;
    model.proposer.proposer_type = api.policy_holder.proposer_type;
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.company_name = api.policy_holder.company_name;
    model.proposer.trading_name = api.policy_holder.trading_name;
    model.proposer.year = api.policy_holder.year_of_establishment;
    model.proposer.address.line1 = api.policy_holder.address.address1;
    model.proposer.address.line2 = api.policy_holder.address.address2;
    model.proposer.address.line3 = api.policy_holder.address.address3;
    model.proposer.address.line4 = api.policy_holder.address.address4;
    model.proposer.address.county = api.policy_holder.address.city;
    model.proposer.address.postcode = api.policy_holder.address.postcode;
    model.proposer.address.country = api.policy_holder.address.country;

    // Preserve vehicles data
    model.vehicles = api.vehicles ?? [];

    // financial details
    if (api.financial_details) {
      model.brokerAdminFee = api.financial_details.broker_admin_fee;
      model.brokerComission = api.financial_details.broker_commission;
    }

    return model;
  }
  showMTACalculation: boolean = false;
  isLoadingMTA: boolean = false;
  onDateChange(newDate: any) {
    this.modelObject.effectiveDate = newDate;
    this.fetchMTAFinancials(); // Will use updated modelObject.effectiveDate
  }
  fetchMTAFinancials(effectiveDate?: string | Date) {
    if (!this.modelObject.id || !this.modelObject.excess_protect_cover_id) {
      console.warn('Missing required data for MTA calculation');
      this.showMTACalculation = false;
      return;
    }

    this.isLoadingMTA = true;
    this.showMTACalculation = false;

    // Use passed date or fall back to modelObject.effectiveDate or current date
    let dateToUse: string;
    if (effectiveDate) {
      // If it's a Date object, convert to ISO string
      dateToUse = effectiveDate instanceof Date
        ? effectiveDate.toISOString().split('T')[0]
        : effectiveDate;
    } else {
      dateToUse = this.modelObject.effectiveDate || new Date().toISOString().split('T')[0];
    }

    // Prepare request payload
    const mtaRequest = {
      quote_id: this.modelObject.id,
      quote_meta_id: this.modelObject.quoteMetaId,
      previous_policy_id: this.apiModelObject?.id, // ID of the policy being modified
      excess_protect_cover_id: this.modelObject.excess_protect_cover_id,
      effective_date: dateToUse,
      type: this.quote_type
    };

    console.log('Fetching MTA Financials:', mtaRequest);

    // Call backend service
    this.excessProtectService.calculateMTAFinancials(mtaRequest)
      .subscribe(
        (response: any) => {
          this.isLoadingMTA = false;

          if (response.success && response.mta_financials) {
            this.mtaFinancials = response.mta_financials;
            this.showMTACalculation = true;

            console.log('MTA Financials received:', this.mtaFinancials);
            this.mtaFinancialsUpdated.emit(this.mtaFinancials);
            console.log('MTA adjustment calculated successfully');
          } else {
            console.warn('No MTA financials in response');
            this.showMTACalculation = false;

            this._snackBar.open('Unable to calculate MTA adjustment', 'Close', {
              duration: 3000,
              panelClass: 'warning-snackbar'
            });
          }
        },
        (error) => {
          this.isLoadingMTA = false;
          this.showMTACalculation = false;

          console.error('Error fetching MTA financials:', error);

          this._snackBar.open('Error calculating MTA adjustment. Please try again.', 'Close', {
            duration: 5000,
            panelClass: 'error-snackbar'
          });
        }
      );
  }

  // Alternative: Only capitalize on blur (when user leaves the field)
  capitalizeField(event: Event, fieldName: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value && value.length > 0) {
      const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);

      const proposerGroup = this.formFields.get('proposer') as FormGroup;
      proposerGroup.get(fieldName)?.setValue(capitalizedValue, { emitEvent: false });
    }
  }
  gePostcodes(compnay_id: any, product_id: any) {
    this.productBasedConfigurationService.getPostcodes(compnay_id, product_id)
      .subscribe(
        (response) => {
          const raw = (response as any).result.postcodes;
          // example raw: "IM, JE, GY, HH"

          if (raw && typeof raw === 'string') {
            this.excludedPrefixes = raw
              .split(',')
              .map(x => x.trim().toUpperCase())
              .filter(x => x.length > 0);
          } else if (Array.isArray(raw)) {
            // safety: if backend ever sends array
            this.excludedPrefixes = raw
              .map(x => String(x).trim().toUpperCase())
              .filter(x => x.length > 0);
          } else {
            this.excludedPrefixes = [];
          }

          console.log('Excluded prefixes loaded:', this.excludedPrefixes);
        },
        (error) => {
          this.excludedPrefixes = [];
        }
      );
  }
}